<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-danger btn-block">
        <li class="fa fa-recycle"></li> SZCS#GPS_DISSLP=0
    </button>
</template>
<script>
    import { Comandos } from '../../class';
    import { Bus } from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.habiliarEconomia(this.id_rastreador, false);
                Bus.$emit('comandos');
            }
        }
    }
</script>
